import React from 'react';
import { Link } from 'react-router-dom';

import Modal from '../../Modal/Modal';

import './SimpleLink.scss';

interface Props {
    text: string;
    arrowRight?: boolean;
    disableAnimation?: boolean;

    // normal link
    link?: string;
    inNewWindow?: boolean;

    // react-router-dom link
    reactRouterDom?: boolean;
    reactRouterDomLink?: string;
    reactRouterDomLinkReplace?: boolean;

    // modal
    modalTitle?: string;
    modalText?: string;
    modalNested?: boolean;
    modalCenterHorizontally?: boolean;
}

const SimpleLink: React.FunctionComponent<Props> = (props) => {
    const [modalVisible, setModalVisibility] = React.useState<boolean>(false);
    const toggleVisibility = () => setModalVisibility(!modalVisible);

    let elementClass = 'simple-link';
    if (props.arrowRight) {
        elementClass += ' simple-link--arrowRight';
    }
    if (props.disableAnimation) {
        elementClass += ' no-animation';
    }

    if (props.modalText) {
        // modal

        elementClass += ' simple-link--modal';
        const nested = Boolean(props.modalNested);
        const centerHorizontally = Boolean(props.modalCenterHorizontally);

        return (
            <>
                <a className={elementClass} onClick={() => setModalVisibility(true)}>
                    {props.arrowRight ? '' : <SimpleLinkIcon />}
                    <span>{props.text}</span>
                    {props.arrowRight ? <SimpleLinkIcon /> : ''}
                </a>
                <Modal
                    visible={modalVisible}
                    toggleVisibility={toggleVisibility}
                    nested={nested}
                    centerHorizontally={centerHorizontally}
                >
                    <div className="info-box">
                        <h2>{props.modalTitle ? props.modalTitle : props.text}</h2>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: props.modalText,
                            }}
                        />
                    </div>
                </Modal>
            </>
        );
    } else if (!props.link) {
        return null;
    } else if (props.reactRouterDom) {
        // react-router-dom link

        if (props.reactRouterDomLinkReplace) {
            return (
                <Link
                    className={elementClass}
                    to={props.reactRouterDomLink ? props.reactRouterDomLink : props.link}
                    replace={true}
                >
                    {props.arrowRight ? '' : <SimpleLinkIcon />}
                    <span>{props.text}</span>
                    {props.arrowRight ? <SimpleLinkIcon /> : ''}
                </Link>
            );
        } else {
            return (
                <Link className={elementClass} to={props.reactRouterDomLink ? props.reactRouterDomLink : props.link}>
                    {props.arrowRight ? '' : <SimpleLinkIcon />}
                    <span>{props.text}</span>
                    {props.arrowRight ? <SimpleLinkIcon /> : ''}
                </Link>
            );
        }
    } else {
        // normal link

        return (
            <a className={elementClass} href={props.link} target={props.inNewWindow ? '_blank' : '_self'}>
                {props.arrowRight ? '' : <SimpleLinkIcon />}
                <span>{props.text}</span>
                {props.arrowRight ? <SimpleLinkIcon /> : ''}
            </a>
        );
    }
};

const SimpleLinkIcon: React.FunctionComponent = () => {
    return (
        <svg className="icon icon--arrow-right">
            <use xlinkHref="#icon-arrow-right" />
        </svg>
    );
};

export default SimpleLink;
